// import axios from "axios";
// import React, { useContext, useEffect, useState } from "react";
// import { RiSignalWifiOffLine, RiSignalWifi3Fill } from "react-icons/ri";
// import styled, { css, keyframes } from "styled-components";
// import pump_image from "../../assets/images/water-pump.png";
// import borewell_image from "../../assets/images/borewell_image.png";
// import { GlobalState } from "../../GlobalState";
// import ToggleButton from "../utils/ToggleButton";
// import Tooltip from "../utils/Tooltip";
// import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom";
// import { formatDate } from "../utils/utils";
// import { GoLocation } from "react-icons/go";
// import { MdUpdate } from "react-icons/md"
// import { RadioTower } from "lucide-react";
// const PumpImg = styled.img`
// width:50px;
// height:100%;
// max-height:50px;
// object-fit:contain;
// `

// const BorewellPumpImg = styled.img`
// width:30px;
// height:100%;
// max-height:50px;
// margin-bottom:0.5rem;
// `

// const RippleAnimation = keyframes`
//   0% {box-shadow: 0 0 0px 0px rgba(101, 255, 120, 0.5);}
//   100% {box-shadow: 0 0 0px 30px rgba(101, 255, 120, 0);}
// `

// const PumpLight = styled.div`
// width:12px;
// height: 12px;
// border-radius:50%;
// background-color: ${props => props.pumpState ? `#00e8a3` : `#d9594c`};
//   ${props => props.pumpState && css`
//     {animation: ${RippleAnimation} 0.7s linear infinite;}`
//   }
// `
// const PumpStateWrapper = styled.div`
// display: flex;
// justify-content: center;
// align-items: center;
// /* margin: 0.5rem;
// `
// const Container = styled.div`
//   // background-color: #fff;
//   cursor: pointer;
//   border-radius: 15px;
//   padding: 0.2rem;
//   // box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
//   margin: 0.1rem;
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   flex-direction: column;
//   // &:hover {
//   //   border: 2px solid var(--primary);
//   // }
//   min-width: 160px;
// `;

// const AnimatedIconWrapper = styled.div`
//   display: inline-flex;
//   justify-content: center;
//   align-items: center;
//   border-radius: 50%;
//   width: 28px;   /* smaller wrapper */
//   height: 28px;  /* smaller wrapper */
//   vertical-align: middle;
//   position: relative;

//   ${({ online }) =>
//     online &&
//     css`
//       &::after {
//         content: "";
//         position: absolute;
//         top: -2px;   /* adjusted for smaller size */
//         left: -2px;
//         width: calc(100% + 4px);
//         height: calc(100% + 4px);
//         border-radius: 50%;
//         animation: ${ripple} 1.5s infinite;
//       }
//     `}
// `;

// const AnimatedIcon = styled(RadioTower)`
//   ${({ online }) =>
//     online &&
//     css`
//       animation: ${pulse} 1.5s infinite;
//       color: green;
//     `}
// `;

// const ripple = keyframes`
//   0% { box-shadow: 0 0 0px 0px rgba(0, 200, 0, 0.5); }
//   100% { box-shadow: 0 0 0px 14px rgba(0, 200, 0, 0); }
// `;

// const SensorStatusIndicator = styled.div`
//   width: 100%;
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   gap: 8px;
// `;

// const TimeElapsed = styled.div`
//   font-size: 0.7rem;
//   font-weight: bold;
//   margin-top:0.3rem;
// `;

// const blinkingRed = keyframes`
//   0% { opacity: 1; }
//   50% { opacity: 0.3; }
//   100% { opacity: 1; }
// `;

// const BlinkingRadioTower = styled(RadioTower)`
//   color: red;
//   animation: ${blinkingRed} 2s infinite;
// `;

// const LocationText = styled.p`
//     font-size: 1.2rem;
//     font-weight:bold;
//     text-align: center;
//     margin: 0.1rem 0;
//     @media (min-width: 61.313em) {
//         text-align: end;
//     }
// `;

// const InfoRow = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 0.3rem;
//   align-items: center;
//   width: 100%;
// `;

// const HPBadge = styled.div`
//   padding: 0.3rem 0.6rem;
//   border-radius: 12px;
//   background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//   color: #fff;
//   font-size: 0.7rem;
//   font-weight: 600;
//   box-shadow: 0 2px 8px rgba(102, 126, 234, 0.25);
// `;

// const gradientShift = keyframes`
//   0% {
//     background-position: -200% center;
//   }
//   100% {
//     background-position: 200% center;
//   }
// `;

// const pulse = keyframes`
//   0%, 100% { 
//     transform: scale(1);
//   }
//   50% { 
//     transform: scale(1.05);
//   }
// `;

// // const LocationName = styled.p`
// //   margin: 0;
// //   opacity: 0;
// //   animation: fadeIn 0.4s ease forwards, ${gradientShift} 2.5s linear infinite, ${pulse} 2s ease-in-out infinite;
// //   font-weight: 1000;
// //   white-space: normal;  
// //   word-break: break-word; 
// //   font-size: 0.9rem;
// //   cursor: pointer;

// //   ${({ $isFaulty, $isOnline }) =>
// //     $isFaulty
// //       ? css`
// //           /* 🔴 FAULTY: Red with BRIGHT YELLOW shiny */
// //           background: linear-gradient(
// //             90deg,
// //             #ef4444 0%,
// //             #ef4444 30%,
// //             #ffeb3b 50%,
// //             #ef4444 70%,
// //             #ef4444 100%
// //           );
// //           background-size: 200% auto;
// //           background-clip: text;
// //           -webkit-background-clip: text;
// //           -webkit-text-fill-color: transparent;
// //         `
// //       : $isOnline
// //         ? css`
// //           /* 🟢 ONLINE: Green with BRIGHT CYAN shiny */
// //           background: linear-gradient(
// //             90deg,
// //             #5ca904 0%,
// //             #5ca904 30%,
// //             #00ffff 50%,
// //             #5ca904 70%,
// //             #5ca904 100%
// //           );
// //           background-size: 200% auto;
// //           background-clip: text;
// //           -webkit-background-clip: text;
// //           -webkit-text-fill-color: transparent;
// //         `
// //         : css`
// //           /* 🟠 OFFLINE: Orange with BRIGHT BLUE shiny */
// //           background: linear-gradient(
// //             90deg,
// //             #ea580c 0%,
// //             #ea580c 30%,
// //             #00bfff 50%,
// //             #ea580c 70%,
// //             #ea580c 100%
// //           );
// //           background-size: 200% auto;
// //           background-clip: text;
// //           -webkit-background-clip: text;
// //           -webkit-text-fill-color: transparent;
// //         `}

// //   @keyframes fadeIn {
// //     to {
// //       opacity: 1;
// //     }
// //   }
// // `;

// const LocationName = styled.p`
//   margin: 0;
//   font-weight: 1000;
//   white-space: normal;  
//   word-break: break-word; 
//   font-size: 0.9rem;
//   cursor: pointer;

//   color: ${({ $isFaulty, $isOnline }) =>
//     $isFaulty ? '#ef4444' : $isOnline ? '#22c55e' : '#ea580c'};
// `;

// export default function PumpStatus({ sensor_id, motor_id, isBorewell }) {
//   const history = useHistory();
//   // get path
//   const location = useLocation();
//   const isDetailPage = location.pathname.includes('/motor/')
//   const state = useContext(GlobalState);

//   const [pumpState, setPumpState] = useState(false)
//   const [pumpData, setPumpData] = useState({})
//   const [sensorStatus, setSensorStatus] = useState('online')
//   const [pumpExist, setPumpExist] = useState(true)

//   const locationName = !pumpData?.motor_status?.location_name ? 'Borewell' : pumpData?.motor_status?.location_name;

//   async function togglePumpStatus(motor_id) {
//     try {
//       setPumpState(!pumpState)
//       const pumpStatus = await axios.get(`${process.env.REACT_APP_API}/sensor/v2/toggle_pump_status?motor_id=${motor_id}`,
//         {
//           headers: { Authorization: state.token[0] },
//         }
//       );
//     } catch (err) {
//       console.log(err.response.data.message);
//     }
//   }


//   // async function fetchData(token, motor_id) {
//   //   try {

//   //     const pumpStatus = await axios.get(`${process.env.REACT_APP_API}/sensor/v2/pump_status?motor_id=${motor_id}`,
//   //       {
//   //         headers: { Authorization: token[0] },
//   //       }
//   //     );
//   //     setPumpData(pumpStatus.data)
//   //     setPumpState(parseInt(pumpStatus.data.motor_status.motor_on))
//   //     setSensorStatus(pumpStatus.data.sensor_status)
//   //   } catch (err) {
//   //     if (err.response.status === 404) {
//   //       setPumpExist(false)
//   //     }

//   //     console.log(err.response.data.message);
//   //   }
//   // }

//   async function fetchData(token, motor_id) {
//   console.log("🔵 PumpStatus fetchData called for motor_id:", motor_id);
//   try {
//     const pumpStatus = await axios.get(`${process.env.REACT_APP_API}/sensor/v2/pump_status?motor_id=${motor_id}`,
//       {
//         headers: { Authorization: token[0] },
//       }
//     );
//     console.log("✅ PumpStatus fetchData completed");
//     setPumpData(pumpStatus.data)
//     setPumpState(parseInt(pumpStatus.data.motor_status.motor_on))
//     setSensorStatus(pumpStatus.data.sensor_status)
//   } catch (err) {
//     if (err.response.status === 404) {
//       setPumpExist(false)
//     }
//     console.log(err.response.data.message);
//   }
// }

//   // useEffect(() => {
//   //   fetchData(state.token, motor_id);
//   //   const interval = setInterval(() => {
//   //     fetchData(state.token, motor_id);
//   //   }, 5000);

//   //   return () => clearInterval(interval);
//   // }, [state.token, motor_id]);

// //   useEffect(() => {
// //   let isMounted = true;
// //   let interval;

// //   async function fetchDataSafely() {
// //     if (!isMounted || document.hidden) return; // Don't fetch if tab is hidden
// //     await fetchData(state.token, motor_id);
// //   }

// //   fetchDataSafely(); // Initial fetch

// //   interval = setInterval(() => {
// //     fetchDataSafely();
// //   }, 10000); // 10 seconds

// //   // Stop polling when tab is hidden
// //   const handleVisibilityChange = () => {
// //     if (document.hidden) {
// //       clearInterval(interval);
// //     } else {
// //       interval = setInterval(fetchDataSafely, 10000);
// //     }
// //   };

// //   document.addEventListener('visibilitychange', handleVisibilityChange);

// //   return () => {
// //     isMounted = false;
// //     clearInterval(interval);
// //     document.removeEventListener('visibilitychange', handleVisibilityChange);
// //   };
// // }, [state.token, motor_id]);

// useEffect(() => {
//   console.log("🟢 PumpStatus mounted, fetching data ONCE (no polling)");
//   fetchData(state.token, motor_id);
//   // NO POLLING - just fetch once
// }, [state.token, motor_id]);

//   if (!pumpExist) return <></>

//   return (
//     <Container>
//       <SensorStatusIndicator>
//         <LocationName $isOnline={sensorStatus === "online"}>
//           {locationName}
//         </LocationName>
//       </SensorStatusIndicator>

//       <PumpStateWrapper>
//         {
//           isBorewell ? <BorewellPumpImg
//             onClick={() => {
//               if (!isBorewell) return
//               history.push(`/motor/${motor_id}/sensor/${sensor_id}/Pump - ${locationName}`)
//             }}
//             src={borewell_image} />
//             : <PumpImg src={pump_image} />

//         }
//         <PumpLight pumpState={pumpState} />
//       </PumpStateWrapper>

//       {
//         !isDetailPage && (<ToggleButton
//           id={motor_id}
//           checked={Boolean(pumpState)}
//           onChange={() => togglePumpStatus(motor_id)}
//         />)
//       }

//       <TimeElapsed>
//         {pumpData?.motor_status?.capacity_in_hp && (
//           <div style={{
//             padding: '0.6rem 0.9rem',
//             borderRadius: '8px',
//             background: 'rgba(102, 126, 234, 0.08)',
//             border: '1px solid rgba(102, 126, 234, 0.2)',
//             color: '#334155',
//             fontSize: '0.9rem',
//             fontWeight: '800',
//             display: 'flex',
//             alignItems: 'center',
//             gap: '0.3rem'
//           }}>
//             <span style={{ color: '#64748b', fontSize: '0.9rem' }}>
//               {pumpData.motor_status.isBorewell ? "Borewell HP:" : "Pump HP:"}
//             </span>

//             <span style={{ color: '#667eea', fontWeight: '700' }}>
//               {pumpData.motor_status.capacity_in_hp}
//             </span>
//           </div>
//         )}
//       </TimeElapsed>
//     </Container>
//   )
// }

// import axios from "axios";
// import React, { useContext, useEffect, useState } from "react";
// import styled, { css, keyframes } from "styled-components";
// import pump_image from "../../assets/images/water-pump.png";
// import borewell_image from "../../assets/images/borewell_image.png";
// import { GlobalState } from "../../GlobalState";
// import ToggleButton from "../utils/ToggleButton";
// import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom";
// import { RadioTower } from "lucide-react";

// const PumpImg = styled.img`
//   width:50px;
//   height:100%;
//   max-height:50px;
//   object-fit:contain;
// `;

// const BorewellPumpImg = styled.img`
//   width:30px;
//   height:100%;
//   max-height:50px;
//   margin-bottom:0.5rem;
// `;

// const RippleAnimation = keyframes`
//   0% {box-shadow: 0 0 0px 0px rgba(101, 255, 120, 0.5);}
//   100% {box-shadow: 0 0 0px 30px rgba(101, 255, 120, 0);}
// `;

// const PumpLight = styled.div`
//   width:12px;
//   height: 12px;
//   border-radius:50%;
//   background-color: ${props => props.pumpState ? `#00e8a3` : `#d9594c`};
//   ${props => props.pumpState && css`
//     animation: ${RippleAnimation} 0.7s linear infinite;
//   `}
// `;

// const PumpStateWrapper = styled.div`
//   display: flex;
//   justify-content: center;
//   align-items: center;
// `;

// const Container = styled.div`
//   cursor: pointer;
//   border-radius: 15px;
//   padding: 0.2rem;
//   margin: 0.1rem;
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   flex-direction: column;
//   min-width: 160px;
// `;

// const SensorStatusIndicator = styled.div`
//   width: 100%;
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
// `;

// const TimeElapsed = styled.div`
//   font-size: 0.7rem;
//   font-weight: bold;
//   margin-top: 0.3rem;
//   width: 100%;
//   padding: 0.3rem 0.5rem;
//   background: rgba(0,0,0,0.04);
//   border-radius: 8px;
// `;

// const LocationName = styled.p`
//   margin: 0;
//   font-weight: 1000;
//   font-size: 0.9rem;
//   color: ${({ $isOnline }) => ($isOnline ? '#22c55e' : '#ea580c')};
// `;

// export default function PumpStatus({ sensor_id, motor_id, isBorewell }) {
//   const history = useHistory();
//   const location = useLocation();
//   const isDetailPage = location.pathname.includes('/motor/');
//   const state = useContext(GlobalState);

//   const [pumpState, setPumpState] = useState(false);
//   const [pumpData, setPumpData] = useState({});
//   const [sensorStatus, setSensorStatus] = useState('online');
//   const [pumpExist, setPumpExist] = useState(true);

//   const locationName =
//     !pumpData?.motor_status?.location_name
//       ? 'Borewell'
//       : pumpData.motor_status.location_name;

//   async function togglePumpStatus(motor_id) {
//     try {
//       await axios.get(
//         `${process.env.REACT_APP_API}/sensor/v2/toggle_pump_status?motor_id=${motor_id}`,
//         { headers: { Authorization: state.token[0] } }
//       );
//     } catch (err) {
//       console.log(err?.response?.data?.message);
//     }
//   }

//   async function fetchData(token, motor_id) {
//     try {
//       const res = await axios.get(
//         `${process.env.REACT_APP_API}/sensor/v2/pump_status?motor_id=${motor_id}`,
//         { headers: { Authorization: token[0] } }
//       );

//       setPumpData(res.data);
//       setPumpState(Boolean(Number(res.data.motor_status.motor_on)));
//       setSensorStatus(res.data.sensor_status);
//     } catch (err) {
//       if (err?.response?.status === 404) {
//         setPumpExist(false);
//       }
//     }
//   }

//   useEffect(() => {
//     let interval;

//     const fetchDataSafely = async () => {
//       if (document.hidden) return;
//       await fetchData(state.token, motor_id);
//     };

//     fetchDataSafely();

//     interval = setInterval(fetchDataSafely, 10000);

//     return () => clearInterval(interval);
//   }, [state.token, motor_id]);

//   if (!pumpExist) return null;

//   return (
//     <Container>
//       <SensorStatusIndicator>
//         <LocationName $isOnline={sensorStatus === "online"}>
//           {locationName}
//         </LocationName>
//       </SensorStatusIndicator>

//       {/* <PumpStateWrapper>
//         {isBorewell ? (
//           <BorewellPumpImg
//             src={borewell_image}
//             onClick={() =>
//               history.push(`/motor/${motor_id}/sensor/${sensor_id}/Pump - ${locationName}`)
//             }
//           />
//         ) : (
//           <PumpImg src={pump_image} />
//         )}
//         <PumpLight pumpState={pumpState} />
//       </PumpStateWrapper> */}

//       {!isDetailPage && (
//         <ToggleButton
//           id={motor_id}
//           checked={pumpState}
//           onChange={() => togglePumpStatus(motor_id)}
//         />
//       )}

//       <TimeElapsed>
//         {pumpData?.motor_status?.capacity_in_hp && (
//           <div style={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             padding: "2px 4px"
//           }}>
//             <span style={{
//               color: pumpState ? "#22c55e" : "#ef4444",
//               fontWeight: 800,
//               fontSize: "0.75rem"
//             }}>
//               {pumpState ? "● ON" : "● OFF"}
//             </span>
//             <span style={{ color: "#475569", fontSize: "0.72rem" }}>
//               {pumpData.motor_status.isBorewell ? "Borewell HP:" : "Pump HP:"}{" "}
//               <strong>{pumpData.motor_status.capacity_in_hp}</strong>
//             </span>
//           </div>
//         )}
//       </TimeElapsed>
//     </Container>
//   );
// }

import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import styled, { css, keyframes } from "styled-components";
import pump_image from "../../assets/images/water-pump.png";
import borewell_image from "../../assets/images/borewell_image.png";
import { GlobalState } from "../../GlobalState";
import ToggleButton from "../utils/ToggleButton";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom";
import { RadioTower } from "lucide-react";

const RippleAnimation = keyframes`
  0% { box-shadow: 0 0 0px 0px rgba(101, 255, 120, 0.5); }
  100% { box-shadow: 0 0 0px 30px rgba(101, 255, 120, 0); }
`;

const PumpLight = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${props => props.pumpState ? `#00e8a3` : `#d9594c`};
  ${props => props.pumpState && css`animation: ${RippleAnimation} 0.7s linear infinite;`}
`;

const PumpStateWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LocationName = styled.p`
  margin: 0;
  font-weight: 1000;
  font-size: 0.9rem;
  color: ${({ $isOnline }) => ($isOnline ? '#22c55e' : '#ea580c')};
`;

const Container = styled.div`
  cursor: pointer;
  border-radius: 15px;
  padding: 0.2rem;
  margin: 0.1rem;
  display: flex;
  justify-content: center;    /* ← center content */
  align-items: center;
  flex-direction: column;
  width: fit-content;
  min-width: 0;               /* ← remove min-width forcing wide */
  max-width: 200px;

  @media (max-width: 768px) {
    width: auto;
    min-width: 0;
    max-width: 180px;
    margin: 0 auto;
  }
`;

const SensorStatusIndicator = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;    /* ← center location name */
`;

const TimeElapsed = styled.div`
  font-size: 0.7rem;
  font-weight: bold;
  margin-top: 0.3rem;
  width: 100%;
  padding: 0.3rem 0.5rem;
  background: rgba(0,0,0,0.04);
  border-radius: 8px;
  box-sizing: border-box;
`;

export default function PumpStatus({ sensor_id, motor_id, isBorewell }) {
  const history = useHistory();
  const location = useLocation();
  const isDetailPage = location.pathname.includes('/motor/');
  const state = useContext(GlobalState);

  const [pumpState, setPumpState] = useState(false);
  const [pumpData, setPumpData] = useState({});
  const [sensorStatus, setSensorStatus] = useState('online');
  const [pumpExist, setPumpExist] = useState(true);

  const locationName =
    !pumpData?.motor_status?.location_name
      ? 'Borewell'
      : pumpData.motor_status.location_name;

  async function togglePumpStatus(motor_id) {
    try {
      await axios.get(
        `${process.env.REACT_APP_API}/sensor/v2/toggle_pump_status?motor_id=${motor_id}`,
        { headers: { Authorization: state.token[0] } }
      );
    } catch (err) {
      console.log(err?.response?.data?.message);
    }
  }

  async function fetchData(token, motor_id) {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API}/sensor/v2/pump_status?motor_id=${motor_id}`,
        { headers: { Authorization: token[0] } }
      );
      setPumpData(res.data);
      setPumpState(Boolean(Number(res.data.motor_status.motor_on)));
      setSensorStatus(res.data.sensor_status);
    } catch (err) {
      if (err?.response?.status === 404) setPumpExist(false);
    }
  }

  useEffect(() => {
    const fetchDataSafely = async () => {
      if (document.hidden) return;
      await fetchData(state.token, motor_id);
    };
    fetchDataSafely();
    const interval = setInterval(fetchDataSafely, 10000);
    return () => clearInterval(interval);
  }, [state.token, motor_id]);

  if (!pumpExist) return null;

  return (
    <Container>
      <SensorStatusIndicator>
        <LocationName $isOnline={sensorStatus === "online"}>
          {locationName}
        </LocationName>
      </SensorStatusIndicator>

      {!isDetailPage && (
        <ToggleButton
          id={motor_id}
          checked={pumpState}
          onChange={() => togglePumpStatus(motor_id)}
        />
      )}

      <TimeElapsed>
        {pumpData?.motor_status?.capacity_in_hp && (
          <div style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "0.5rem",
            padding: "2px 4px"
          }}>
            <span style={{ color: pumpState ? "#22c55e" : "#ef4444", fontWeight: 800, fontSize: "0.85rem" }}>
              {pumpState ? "● ON" : "● OFF"}
            </span>
            <span style={{ color: "#475569", fontSize: "0.85rem" }}>
              {pumpData.motor_status.isBorewell ? "Borewell HP:" : "Pump HP:"}{" "}
              <strong>{pumpData.motor_status.capacity_in_hp}</strong>
            </span>
          </div>
        )}
      </TimeElapsed>
    </Container>
  );
}